import { baseTr, baseEn, type BaseMessageKey } from "@csa/web-foundation";

// Turkish-FIRST i18n (ADR 0016 / the customer surface is Turkish-primary). The base
// chrome strings (auth, generic) live in @csa/web-foundation and are merged below.
export const tr = {
  "app.title": "CSA Privé",
  "app.tagline": "Müşteri Deneyimi",
  "nav.section": "Genel Bakış",
  "shell.role": "Müşteri",
  "shell.openNav": "Menüyü aç",
  "shell.closeNav": "Menüyü kapat",
  "nav.home": "Ana Sayfa",
  "nav.profile": "Profilim",
  "nav.consents": "İzinlerim",
  "nav.messages": "Mesajlar",
  "nav.proposal": "Teklifiniz",
  "nav.policies": "Portföyüm",
  "nav.household": "Hanem",
  "nav.renewals": "Yenilemeler",
  "nav.claims": "Hasarlarım",

  // CUST-PORTFOLIO-UI — N1/N2/N4/N5 surfaces + Mesajlar stub
  "port.loadError": "Şu an yüklenemedi. Danışmanınıza başvurabilirsiniz.",
  "port.perYear": "/ yıl",
  "port.policyNo": "Poliçe no",
  "port.lossAt": "Hasar tarihi",
  "port.daysLeft": "gün kaldı",
  "port.metric.premium": "Prim",
  "port.metric.renewal": "Yenileme",
  "port.metric.term": "Dönem",
  "port.metric.status": "Durum",
  "port.metric.amount": "Ödeme",
  "port.policies.sub": "Hanenizdeki her poliçe — güvende ve güncel.",
  "port.household.sub": "Hanenizin sigortalı varlıkları, tek görünümde.",
  "port.renewals.sub": "Yaklaşan yenilemeleriniz — zamanında haberdar olun.",
  "port.claims.sub": "Hasar süreçleriniz — baştan sona sizin için takipte.",
  "port.addAsset": "Varlık ekle",
  "port.line.trafik": "Zorunlu Trafik",
  "port.line.kasko": "Kasko",
  "port.asset.VEHICLE": "Araç",
  "port.asset.DWELLING": "Konut",
  "port.policies.title": "Poliçelerim",
  "port.policies.empty":
    "Henüz poliçeniz görünmüyor. Danışmanınız bir teklif hazırlayıp poliçeleştirdiğinde burada olacak.",
  "port.household.title": "Hanem",
  "port.household.since": "Sahiplik",
  "port.household.assets": "Sigortalı varlıklar",
  "port.household.empty": "Henüz kayıtlı bir sigortalı varlık yok.",
  "port.renewals.title": "Yenilemeler",
  "port.renewals.empty": "Yaklaşan bir yenileme yok.",
  "port.renewal.UPCOMING": "Yaklaşıyor",
  "port.renewal.RENEWED": "Yenilendi",
  "port.renewal.LAPSED": "Kaçırıldı",
  "port.claims.title": "Hasarlarım",
  "port.claims.empty": "Hasar kaydınız yok — umarız hep böyle kalır.",
  "msg.title": "Mesajlar",
  "msg.body": "Danışmanınızla iletişim yakında buradan yürüyecek.",
  "msg.soon": "Şimdilik sorularınız için danışmanınıza doğrudan ulaşabilirsiniz.",
  "shell.loading": "Yükleniyor…",
  "placeholder.soon": "Bu ekran yakında burada olacak.",

  // TF1 — onboarding / linking + auth UX + landing
  "gate.error": "Bir şeyler ters gitti. Danışmanınıza başvurun.",
  "onb.title": "Hesabınızı etkinleştirin",
  "onb.selfHint": "Davetiyeniz yoksa T.C. kimlik numaranızla doğrulayın.",
  "onb.tcknLabel": "T.C. Kimlik No",
  "onb.tcknHint": "Sunucuda doğrulanır — parola değildir.",
  "onb.continue": "Devam",
  "onb.otpSent": "Doğrulama kodu telefonunuza gönderildi.",
  "onb.otpLabel": "Doğrulama kodu",
  "onb.verify": "Doğrula",
  "onb.denied": "DOĞRULANAMADI",
  "onb.inviteTitle": "Hesabınızı etkinleştirin",
  "onb.inviteBody": "Danışmanınız hesabınızı hazırladı.",
  "onb.activate": "Etkinleştir",
  "onb.advisor": "Sorun mu var? Danışmanınıza başvurun.",
  "locked.title": "Çok fazla deneme",
  "locked.body": "Kısa süre bekleyin veya danışmanınızdan davet isteyin.",
  "onb.done.title": "Hesabınız hazır",
  "onb.done.body":
    "Poliçeleriniz, yenilemeleriniz ve hasarlarınız artık burada. Girişte telefonunuza tek kullanımlık kod göndeririz.",
  "onb.done.continue": "Devam et",
  "home.ready": "Hazırsınız",
  "home.concierge": "Danışmanınız hesabınızı hazırladı. Her şey hazır.",
  "home.proposalReady": "Teklifiniz hazır",
  "home.proposalReadyBody": "Danışmanınız sizin için bir teklif hazırladı.",
  "home.proposalReadyCta": "Teklifi görüntüle",

  // TF2 — consent ledger + 7-step + no-spam panel
  "cs.title": "İzinleriniz",
  "cs.subtitle": "Verdiğiniz her izin burada — görünür, sürümlü, istediğinizde geri alınabilir.",
  "cs.error": "İzinleriniz şu an yüklenemedi. Danışmanınıza başvurabilirsiniz.",
  "cs.stepsTitle": "Onay adımlarınız",
  "cs.captureNote":
    "Zorunlu onaylar teklif aşamasında alınır; burada tümünü görür ve pazarlama izinlerinizi yönetirsiniz.",
  "cs.step.notice": "Aydınlatma metni",
  "cs.step.general": "Genel açık rıza",
  "cs.step.health": "Sağlık verisi açık rızası",
  "cs.step.terms": "Üyelik ve hizmet şartları",
  "cs.step.distance": "Mesafeli satış ön bilgilendirmesi",
  "cs.step.marketing": "Pazarlama izni (İYS)",
  "cs.step.cookie": "Çerez tercihleri",
  "cs.state.captured": "Onaylandı",
  "cs.state.notRecorded": "Kaydınızda görünmüyor",
  "cs.state.manageBelow": "Aşağıdan yönetin",
  "cs.state.optional": "İsteğe bağlı",
  "cs.ledgerTitle": "Verdiğiniz izinler",
  "cs.ledgerEmpty": "Henüz bir pazarlama izni vermediniz. Bu bir başlangıç, bir eksik değil.",
  "cs.asOf": "Şu tarihten beri:",
  "cs.withdraw": "Geri al",
  "cs.purpose.marketing": "Pazarlama iletişimi",
  "cs.channel.SMS": "SMS",
  "cs.channel.EMAIL": "E-posta",
  "cs.channel.PHONE": "Telefonla arama",
  "cs.channel.PUSH": "Uygulama bildirimi",
  "cs.nospamTitle": "Sizi rahatsız etmeme sözü",
  "cs.serviceTitle": "Hizmet, yenileme ve hasar bilgileri",
  "cs.serviceBody": "Bunlar hizmet, reklam değil — her zaman açıktır, ayrı bir izin gerektirmez.",
  "cs.alwaysOn": "Her zaman açık",
  "cs.marketingBody": "Pazarlama iletişimi varsayılan olarak kapalıdır. İstediğiniz kanalı açın.",
  "cs.turnOn": "Aç",
  "cs.turnOff": "Kapat",
  "cs.suppressionTitle": "Sizi aramadığımız anlar",
  "cs.suppressionBody":
    "Size ne zaman ulaşmadığımızın kaydı — şeffaflık için yakında burada olacak.",
  "cs.soon": "Yakında",
  "cs.actionFailed": "İzin tercihiniz kaydedilemedi. Önceki durum geçerli.",
  "onb.ceremonyFailed": "İşlem tamamlanamadı. Lütfen biraz sonra tekrar deneyin.",
  "onb.offline": "Bağlantı kurulamadı. Talep sunucuya ulaşmadı.",
  "pr.respondFailed": "Yanıtınız kaydedilemedi. Teklif değişmedi.",
  "pr.offline": "Bağlantı kurulamadı. Yanıtınız sunucuya ulaşmadı.",
  "cs.offline": "Bağlantı kurulamadı. İzin tercihiniz sunucuya ulaşmadı.",
  "cs.noMarketingNotice":
    "Pazarlama aydınlatma metni hesabınızda görünmüyor, bu yüzden kanal izinleri şu an açılamıyor. Danışmanınız bunu sizin için düzeltebilir.",
  "cs.stepupNote":
    "Sizi doğrulayalım — bu, izninizin gerçekten size ait olması için bir korumadır.",

  // TF3 — masked profile + settings
  "pf.title": "Profiliniz",
  "pf.error": "Profiliniz şu an yüklenemedi. Danışmanınıza başvurabilirsiniz.",
  "pf.name": "Ad Soyad",
  "pf.tckn": "T.C. Kimlik No",
  "pf.tcknNote": "Korumalı — sunucuda saklanır, size bile yalnızca maskeli gösterilir.",
  "pf.soon": "Yakında",
  "pf.advisorTitle": "Danışmanınız",
  "pf.advisorNote": "Sorularınız için danışmanınız yanınızda.",
  "pf.advisorMsg": "Mesaj gönder",
  // Dalga-1: in-app mesajlaşma henüz yok. CTA yerine dürüst, uca çıkmayan bilgi.
  "pf.advisorReach": "Danışmanınız sizinle iletişime geçecek.",
  "pf.contactTitle": "İletişim bilgileri",
  "pf.contactNote":
    "Telefon ve e-postanız görüntülemeye özeldir. Güncelleme, güvenlik doğrulaması gerektirir — yakında.",
  // Profil / Hesabım — düzenlenebilir kişisel bilgiler + Güvenlik paneli
  "pf.firstName": "Ad",
  "pf.lastName": "Soyad",
  "pf.email": "E-posta",
  "pf.emailHint": "E-postanızı burada güncelleyebilirsiniz.",
  "pf.emailPlaceholder": "ornek@eposta.com",
  "pf.phone": "Telefon",
  "pf.phoneNote":
    "Telefonunuzu değiştirmek güvenlik doğrulaması gerektirir — danışmanınız yardımcı olur.",
  "pf.edit": "Düzenle",
  "pf.save": "Kaydet",
  "pf.saving": "Kaydediliyor…",
  "pf.cancel": "Vazgeç",
  "pf.saveOk": "Bilgileriniz güncellendi.",
  "pf.saveError": "Bilgileriniz kaydedilemedi. Lütfen tekrar deneyin.",
  "pf.securityTitle": "Güvenlik",
  "pf.loginOtpTitle": "Giriş doğrulaması",
  "pf.loginOtpNote":
    "Her girişte telefonunuza gelen tek kullanımlık kodla ekstra doğrulama. Kapatsanız da ilk kayıt doğrulaması her zaman geçerlidir.",
  "pf.loginOtpError": "Ayar değiştirilemedi. Lütfen tekrar deneyin.",
  "pf.passwordTitle": "Şifre değiştir",
  "pf.passwordNote": "Mevcut şifrenizi doğrulayıp yeni bir şifre belirleyin.",
  "pf.passwordAction": "Şifre değiştir",
  "pf.pwCurrent": "Mevcut şifre",
  "pf.pwNew": "Yeni şifre",
  "pf.pwConfirm": "Yeni şifre (tekrar)",
  "pf.pwHint": "En az 6 karakter.",
  "pf.pwSubmit": "Şifreyi güncelle",
  "pf.pwOk": "Şifreniz güncellendi.",
  "pf.pwWrong": "Mevcut şifreniz hatalı.",
  "pf.pwMismatch": "Yeni şifreler eşleşmiyor.",
  "pf.pwTooShort": "Yeni şifre en az 6 karakter olmalı.",
  "pf.pwUnavailable": "Şifre değiştirme şu an yapılamıyor. Lütfen daha sonra tekrar deneyin.",
  "pf.pwError": "Şifreniz güncellenemedi. Lütfen tekrar deneyin.",
  "set.title": "Ayarlar",
  "set.langTitle": "Dil",
  "set.lang.tr": "Türkçe",
  "set.lang.en": "English",
  "set.a11yTitle": "Erişilebilirlik",
  "set.textSize": "Yazı boyutu",
  "set.textSize.normal": "Normal",
  "set.textSize.large": "Büyük",
  "set.reducedMotion": "Hareketi azalt",
  "set.highContrast": "Yüksek kontrast",
  "set.on": "Açık",
  "set.off": "Kapalı",
  "set.securityTitle": "Güvenlik",
  "set.securityNote":
    "Parolasız giriş (passkey) ve kısa oturumlar — sizi korumak için. Şifre ezberlemek yok.",
  "set.passkeyFlag": "Passkey ve cihaz yönetimi yakında bu ekrandan yapılabilecek.",
  "set.linksTitle": "İlgili sayfalar",
  "set.linkConsents": "İzinlerinizi yönetin",
  "set.linkDataRights": "Verilerinize erişim ve silme (KVKK)",
  "set.dataRightsNote":
    "Verilerinize erişmek veya silinmesini istemek için danışmanınıza ya da desteğe başvurun.",

  // C0 — customer proposal page
  "pp.title": "Teklifiniz hazır",
  "pp.advisorGeneric": "Danışmanınız",
  "pp.listTitle": "Teklifleriniz",
  "pp.listBody": "Birden fazla aktif teklifiniz var. Görüntülemek için seçin.",
  "pp.aProposal": "Teklif",
  "pp.line.trafik": "Zorunlu Trafik Sigortası",
  "pp.line.kasko": "Kasko",
  "pp.emptyTitle": "Şu an aktif teklifiniz yok",
  "pp.errorTitle": "Teklifleriniz şu an yüklenemedi",
  "pp.errorBody": "Geçici bir sorun olabilir. Lütfen birazdan tekrar deneyin.",
  "pp.emptyBody": "Danışmanınız sizin için bir teklif hazırladığında burada görürsünüz.",
  "pp.error": "Teklifiniz şu an yüklenemedi. Danışmanınıza başvurabilirsiniz.",
  "pp.decidedBadge": "Onaylandı",
  "pp.decidedBody": "Danışmanınız onayladı — poliçeniz hazırlanıyor.",
  "pp.recommended": "Önerilen",
  "pp.perYear": "/ yıl",
  "pp.band.EXCELLENT": "Mükemmel",
  "pp.band.STRONG": "Güçlü",
  "pp.band.GOOD": "İyi",
  "pp.band.FAIR": "Orta",
  "pp.whyTitle": "Bu öneri neden?",
  "pp.whyFallback":
    "Danışmanınız bu teklifi ihtiyaçlarınıza en uygun seçenek olarak değerlendirdi.",
  "pp.othersTitle": "Diğer teklifler",
  "pp.factorsTitle": "Uygunluk detayları",
  "pp.factor.needsFit": "İhtiyaç uyumu",
  "pp.factor.carrierQuality": "Sigortacı kalitesi",
  "pp.factor.coverageQualityVsNeeds": "Teminat–ihtiyaç uyumu",
  "pp.factor.priceValue": "Fiyat / değer",
  "pp.disclosure":
    "Bu teklifler, çalıştığımız sigorta şirketleri paneli içinden sizin için seçilen en uygun seçeneklerdir; tüm piyasayı kapsayan bağımsız bir karşılaştırma değildir.",
  "pp.readback.ACCEPTED": "Bu teklifi kabul ettiniz",
  "pp.readback.DEFERRED": "Daha sonra karar vereceğinizi ilettiniz",
  "pp.readback.DECLINED": "Bu teklifi istemediğinizi ilettiniz",
  "pp.success.ACCEPTED": "İletildi — danışmanınız onaylayıp poliçenizi hazırlayacak.",
  "pp.success.DEFERRED": "Not aldık — acele yok.",
  "pp.success.DECLINED": "Teşekkürler, ilettik.",
  "pp.pdf": "PDF indir",
  "pp.pdfLoading": "PDF hazırlanıyor…",
  "pp.pdfError": "PDF alınamadı — lütfen tekrar deneyin.",
  "pp.accept": "Öneriyi kabul et",
  "pp.defer": "Daha sonra",
  "pp.ask": "Danışmana soru sor",
  "pp.askNote": "Sorularınız mı var? Danışmanınız sizinle iletişime geçecek.",
  "pp.decline": "Bu teklifi istemiyorum",
  // N3 (#208) — plain offer-validity info (NO countdown, no urgency), the advisor note
  // box, and the calmer "daha sonra" copy. {date} is filled from quoteValidUntil.
  "pp.validity":
    "Teklif geçerliliği: {date} · süre dolarsa {advisor} güncel teklifi yeniden hazırlar.",
  "pp.advisorNoteTitle": "Danışmanınızdan not",
  // N3 (#210) — the named variant, used when advisorName resolves; {advisor} is a real
  // display name (simple possessive, no vowel-harmony branching). {advisor} in the copy
  // below falls back to "danışmanınız" when the name is null (never a fake name).
  "pp.advisorNoteTitleNamed": "{advisor}'den not",
  "pp.advisorFallback": "danışmanınız",
  "pp.deferNote":
    "Not aldık. Acele yok — teklif {date}'e dek geçerli. Bu arada {advisor} sizi aramayacak; hazır olduğunuzda buradan yanıtlarsınız.",
  "pp.deferNoteNoDate":
    "Not aldık. Acele yok. Bu arada {advisor} sizi aramayacak; hazır olduğunuzda buradan yanıtlarsınız.",

  // TEKLIF-AL — the authenticated re-quote surface (System-1). Warm, reassuring; a known,
  // returning customer requests a new quote from their own page. No price shown (the moat).
  "nav.quote": "Teklif Al",
  "qr.title": "Teklif Al",
  "qr.subtitle": "Yeni bir teklif için birkaç bilgi yeterli — gerisini danışmanınız hallediyor.",
  "qr.forWhom": "Kimin için",
  "qr.name": "Ad Soyad",
  "qr.phone": "Telefon",
  "qr.email": "E-posta",
  "qr.forWhomNote":
    "Bu talep sizin adınıza oluşturulur. Kimlik bilgileriniz zaten kayıtlı — tekrar girmenize gerek yok.",
  "qr.pickProduct": "Hangi ürün için?",
  "qr.product.trafik": "Zorunlu Trafik",
  "qr.product.kasko": "Kasko",
  "qr.product.dask": "DASK",
  "qr.product.seyahat": "Seyahat Sağlık",
  "qr.product.saglik": "Sağlık",
  "qr.fieldsNote": "Yalnızca bu ürün için gerekli bilgileri istiyoruz.",
  "qr.f.plate": "Plaka",
  "qr.f.plateHint": "Örn. 34 ABC 123",
  "qr.f.vin": "Şasi No (VIN) — isteğe bağlı",
  "qr.f.vinHint": "Plaka yerine şasi numarasını da girebilirsiniz.",
  "qr.f.address": "Adres",
  "qr.f.uavt": "UAVT Adres Kodu — isteğe bağlı",
  "qr.f.uavtHint": "10 haneli adres kodu (biliyorsanız).",
  "qr.f.grossM2": "Brüt m²",
  "qr.f.structure": "Yapı tarzı",
  "qr.f.buildYear": "Yapım yılı",
  "qr.f.floor": "Bulunduğu kat",
  "qr.f.choose": "Seçiniz",
  "qr.structure.betonarme": "Betonarme",
  "qr.structure.celik": "Çelik",
  "qr.structure.yigma": "Yığma",
  "qr.structure.diger": "Diğer",
  "qr.f.destination": "Gidilecek ülke / bölge",
  "qr.f.startDate": "Başlangıç tarihi",
  "qr.f.endDate": "Bitiş tarihi",
  "qr.f.travelers": "Kişi sayısı",
  "qr.f.sgk": "SGK durumu",
  "qr.sgk.sgkli": "SGK'lı",
  "qr.sgk.sgksiz": "SGK'sız",
  "qr.sgk.bilinmiyor": "Bilmiyorum",
  "qr.f.hospital": "Hastane tercihi — isteğe bağlı",
  "qr.f.declarationNote":
    "Sağlık beyanınız, gizliliğiniz için danışmanınızla çevrimdışı tamamlanır.",
  "qr.f.acikRiza": "Sağlık verilerimin bu teklif için işlenmesine açık rıza veriyorum.",
  "qr.submit": "Talebi gönder",
  "qr.submitting": "Gönderiliyor…",
  "qr.successTitle": "Talebiniz alındı",
  "qr.successBody": "Danışmanınız en kısa sürede sizin için teklifleri hazırlayacak.",
  "qr.newRequest": "Yeni bir talep oluştur",
  "qr.profileError": "Şu an yüklenemedi. Danışmanınıza başvurabilirsiniz.",
  "qr.err.vehicleRequired": "Lütfen plaka veya şasi numarası girin.",
  "qr.err.plateFormat": "Plakayı örnekteki gibi girin (34 ABC 123).",
  "qr.err.addressRequired": "Lütfen adres girin.",
  "qr.err.uavtFormat": "UAVT kodu 10 haneli olmalı.",
  "qr.err.destinationRequired": "Lütfen gidilecek yeri girin.",
  "qr.err.acikRizaRequired": "Devam etmek için açık rıza gerekli.",
  "qr.err.rate": "Çok sık denediniz — lütfen biraz sonra tekrar deneyin.",
  "qr.err.generic": "Talebiniz gönderilemedi — lütfen tekrar deneyin.",
} as const;

export type CustomerMessageKey = keyof typeof tr;
export type MessageKey = BaseMessageKey | CustomerMessageKey;

export const en: Record<CustomerMessageKey, string> = {
  "app.title": "CSA Privé",
  "app.tagline": "Customer Experience",
  "nav.section": "Overview",
  "shell.role": "Member",
  "shell.openNav": "Open menu",
  "shell.closeNav": "Close menu",
  "nav.home": "Home",
  "nav.profile": "My profile",
  "nav.consents": "My consents",
  "nav.messages": "Messages",
  "nav.proposal": "Your proposal",
  "nav.policies": "My portfolio",
  "nav.household": "My household",
  "nav.renewals": "Renewals",
  "nav.claims": "My claims",

  // CUST-PORTFOLIO-UI — N1/N2/N4/N5 surfaces + Messages stub
  "port.loadError": "We couldn't load this right now. You can contact your advisor.",
  "port.perYear": "/ year",
  "port.policyNo": "Policy no",
  "port.lossAt": "Loss date",
  "port.daysLeft": "days left",
  "port.metric.premium": "Premium",
  "port.metric.renewal": "Renewal",
  "port.metric.term": "Term",
  "port.metric.status": "Status",
  "port.metric.amount": "Payout",
  "port.policies.sub": "Every policy in your household — safe and current.",
  "port.household.sub": "Your household's insured assets, in one view.",
  "port.renewals.sub": "Your upcoming renewals — so you're notified in good time.",
  "port.claims.sub": "Your claims — followed for you, from start to finish.",
  "port.addAsset": "Add asset",
  "port.line.trafik": "Compulsory MTPL",
  "port.line.kasko": "Kasko",
  "port.asset.VEHICLE": "Vehicle",
  "port.asset.DWELLING": "Dwelling",
  "port.policies.title": "My policies",
  "port.policies.empty":
    "You have no policies yet. They'll appear here once your advisor prepares and issues one.",
  "port.household.title": "My household",
  "port.household.since": "Owned since",
  "port.household.assets": "Insured assets",
  "port.household.empty": "No insured assets on file yet.",
  "port.renewals.title": "Renewals",
  "port.renewals.empty": "No upcoming renewals.",
  "port.renewal.UPCOMING": "Upcoming",
  "port.renewal.RENEWED": "Renewed",
  "port.renewal.LAPSED": "Lapsed",
  "port.claims.title": "My claims",
  "port.claims.empty": "You have no claims — long may it stay that way.",
  "msg.title": "Messages",
  "msg.body": "Messaging with your advisor will live here soon.",
  "msg.soon": "For now, you can reach your advisor directly with any questions.",
  "shell.loading": "Loading…",
  "placeholder.soon": "This screen is coming soon.",

  // TF1 — onboarding / linking + auth UX + landing
  "gate.error": "Something went wrong. Please contact your advisor.",
  "onb.title": "Activate your account",
  "onb.selfHint": "No invitation? Verify with your national ID number.",
  "onb.tcknLabel": "National ID (TCKN)",
  "onb.tcknHint": "Verified on the server — it is not a password.",
  "onb.continue": "Continue",
  "onb.otpSent": "A verification code was sent to your phone.",
  "onb.otpLabel": "Verification code",
  "onb.verify": "Verify",
  "onb.denied": "COULD NOT VERIFY",
  "onb.inviteTitle": "Activate your account",
  "onb.inviteBody": "Your advisor has set up your account.",
  "onb.activate": "Activate",
  "onb.advisor": "Trouble? Contact your advisor.",
  "locked.title": "Too many attempts",
  "locked.body": "Please wait a little, or ask your advisor for an invitation.",
  "onb.done.title": "Your account is ready",
  "onb.done.body":
    "Your policies, renewals and claims live here now. We send a one-time code to your phone when you sign in.",
  "onb.done.continue": "Continue",
  "home.ready": "You're all set",
  "home.concierge": "Your advisor prepared your account. Everything's ready.",
  "home.proposalReady": "Your proposal is ready",
  "home.proposalReadyBody": "Your advisor has prepared a proposal for you.",
  "home.proposalReadyCta": "View the proposal",

  // TF2 — consent ledger + 7-step + no-spam panel
  "cs.title": "Your consents",
  "cs.subtitle":
    "Every permission you've given — visible, versioned, withdrawable whenever you choose.",
  "cs.error": "We couldn't load your consents right now. You can contact your advisor.",
  "cs.stepsTitle": "Your consent steps",
  "cs.captureNote":
    "Required consents are captured during the quote; here you see them all and manage your marketing permissions.",
  "cs.step.notice": "Privacy notice",
  "cs.step.general": "General explicit consent",
  "cs.step.health": "Health-data explicit consent",
  "cs.step.terms": "Membership and service terms",
  "cs.step.distance": "Distance-sales pre-disclosure",
  "cs.step.marketing": "Marketing consent (İYS)",
  "cs.step.cookie": "Cookie preferences",
  "cs.state.captured": "Granted",
  "cs.state.notRecorded": "Not in your record",
  "cs.state.manageBelow": "Manage below",
  "cs.state.optional": "Optional",
  "cs.ledgerTitle": "Consents you've given",
  "cs.ledgerEmpty": "You haven't granted any marketing consent yet. That's a beginning, not a gap.",
  "cs.asOf": "As of",
  "cs.withdraw": "Withdraw",
  "cs.purpose.marketing": "Marketing communication",
  "cs.channel.SMS": "SMS",
  "cs.channel.EMAIL": "Email",
  "cs.channel.PHONE": "Phone call",
  "cs.channel.PUSH": "App notification",
  "cs.nospamTitle": "Our promise not to spam you",
  "cs.serviceTitle": "Service, renewal and claim information",
  "cs.serviceBody": "This is service, not advertising — always on, no separate consent needed.",
  "cs.alwaysOn": "Always on",
  "cs.marketingBody": "Marketing is off by default. Turn on any channel you'd like.",
  "cs.turnOn": "Turn on",
  "cs.turnOff": "Turn off",
  "cs.suppressionTitle": "The times we don't call you",
  "cs.suppressionBody":
    "A record of when we chose not to reach you — coming here soon, for transparency.",
  "cs.soon": "Soon",
  "cs.actionFailed": "Your permission was not saved. The previous setting still applies.",
  "onb.ceremonyFailed": "That did not go through. Please try again shortly.",
  "onb.offline": "No connection. The request never reached the server.",
  "pr.respondFailed": "Your response was not saved. The proposal is unchanged.",
  "pr.offline": "No connection. Your response never reached the server.",
  "cs.offline": "No connection. Your permission never reached the server.",
  "cs.noMarketingNotice":
    "No marketing disclosure is on file for your account, so channel permissions cannot be turned on yet. Your advisor can fix this for you.",
  "cs.stepupNote": "Let's verify it's you — a protection so this permission is truly yours.",

  // TF3 — masked profile + settings
  "pf.title": "Your profile",
  "pf.error": "We couldn't load your profile right now. You can contact your advisor.",
  "pf.name": "Full name",
  "pf.tckn": "National ID (TCKN)",
  "pf.tcknNote": "Protected — stored on the server and shown only masked, even to you.",
  "pf.soon": "Soon",
  "pf.advisorTitle": "Your advisor",
  "pf.advisorNote": "Your advisor is here for your questions.",
  "pf.advisorMsg": "Send a message",
  "pf.advisorReach": "Your advisor will reach out to you.",
  "pf.contactTitle": "Contact details",
  "pf.contactNote":
    "Your phone and e-mail are view-only. Updating them requires a security check — coming soon.",
  // Profile / Account — editable personal info + Security panel
  "pf.firstName": "First name",
  "pf.lastName": "Last name",
  "pf.email": "E-mail",
  "pf.emailHint": "You can update your e-mail here.",
  "pf.emailPlaceholder": "you@example.com",
  "pf.phone": "Phone",
  "pf.phoneNote": "Changing your phone requires a security check — your advisor can help.",
  "pf.edit": "Edit",
  "pf.save": "Save",
  "pf.saving": "Saving…",
  "pf.cancel": "Cancel",
  "pf.saveOk": "Your details were updated.",
  "pf.saveError": "We couldn't save your details. Please try again.",
  "pf.securityTitle": "Security",
  "pf.loginOtpTitle": "Login verification",
  "pf.loginOtpNote":
    "Extra verification with a one-time code sent to your phone at each sign-in. Even if you turn it off, first-registration verification always applies.",
  "pf.loginOtpError": "We couldn't change the setting. Please try again.",
  "pf.passwordTitle": "Change password",
  "pf.passwordNote": "Verify your current password and set a new one.",
  "pf.passwordAction": "Change password",
  "pf.pwCurrent": "Current password",
  "pf.pwNew": "New password",
  "pf.pwConfirm": "New password (again)",
  "pf.pwHint": "At least 6 characters.",
  "pf.pwSubmit": "Update password",
  "pf.pwOk": "Your password was updated.",
  "pf.pwWrong": "Your current password is incorrect.",
  "pf.pwMismatch": "The new passwords don't match.",
  "pf.pwTooShort": "The new password must be at least 6 characters.",
  "pf.pwUnavailable": "Password change isn't available right now. Please try again later.",
  "pf.pwError": "We couldn't update your password. Please try again.",
  "set.title": "Settings",
  "set.langTitle": "Language",
  "set.lang.tr": "Türkçe",
  "set.lang.en": "English",
  "set.a11yTitle": "Accessibility",
  "set.textSize": "Text size",
  "set.textSize.normal": "Normal",
  "set.textSize.large": "Large",
  "set.reducedMotion": "Reduce motion",
  "set.highContrast": "High contrast",
  "set.on": "On",
  "set.off": "Off",
  "set.securityTitle": "Security",
  "set.securityNote":
    "Passwordless sign-in (passkey) and short sessions — to protect you. No passwords to memorize.",
  "set.passkeyFlag": "Passkey and device management will be available from this screen soon.",
  "set.linksTitle": "Related pages",
  "set.linkConsents": "Manage your consents",
  "set.linkDataRights": "Access and erase your data (KVKK)",
  "set.dataRightsNote":
    "To access your data or request erasure, please contact your advisor or support.",

  // C0 — customer proposal page
  "pp.title": "Your proposal is ready",
  "pp.advisorGeneric": "Your advisor",
  "pp.listTitle": "Your proposals",
  "pp.listBody": "You have more than one active proposal. Choose one to view.",
  "pp.aProposal": "Proposal",
  "pp.line.trafik": "Compulsory Motor Third-Party Liability",
  "pp.line.kasko": "Motor Own Damage (Kasko)",
  "pp.emptyTitle": "You have no active proposal right now",
  "pp.errorTitle": "We couldn’t load your proposals",
  "pp.errorBody": "This may be a temporary problem. Please try again shortly.",
  "pp.emptyBody": "When your advisor prepares a proposal for you, you'll see it here.",
  "pp.error": "We couldn't load your proposal right now. You can contact your advisor.",
  "pp.decidedBadge": "Confirmed",
  "pp.decidedBody": "Your advisor has confirmed — your policy is being prepared.",
  "pp.recommended": "Recommended",
  "pp.perYear": "/ year",
  "pp.band.EXCELLENT": "Excellent",
  "pp.band.STRONG": "Strong",
  "pp.band.GOOD": "Good",
  "pp.band.FAIR": "Fair",
  "pp.whyTitle": "Why this recommendation?",
  "pp.whyFallback": "Your advisor judged this the most suitable option for your needs.",
  "pp.othersTitle": "Other offers",
  "pp.factorsTitle": "Suitability details",
  "pp.factor.needsFit": "Needs fit",
  "pp.factor.carrierQuality": "Carrier quality",
  "pp.factor.coverageQualityVsNeeds": "Coverage vs needs",
  "pp.factor.priceValue": "Price / value",
  "pp.disclosure":
    "These offers are the most suitable options selected for you from our panel of insurers; they are not an independent whole-of-market comparison.",
  "pp.readback.ACCEPTED": "You accepted this proposal",
  "pp.readback.DEFERRED": "You said you'd decide later",
  "pp.readback.DECLINED": "You said you didn't want this proposal",
  "pp.success.ACCEPTED": "Sent — your advisor will confirm and prepare your policy.",
  "pp.success.DEFERRED": "Noted — no rush.",
  "pp.success.DECLINED": "Thank you, we've passed it on.",
  "pp.pdf": "Download PDF",
  "pp.pdfLoading": "Preparing PDF…",
  "pp.pdfError": "Couldn't fetch the PDF — please try again.",
  "pp.accept": "Accept the recommendation",
  "pp.defer": "Later",
  "pp.ask": "Ask your advisor",
  "pp.askNote": "Have questions? Your advisor will reach out to you.",
  "pp.decline": "I don't want this proposal",
  // N3 (#208) — plain offer-validity info (NO countdown, no urgency), the advisor note
  // box, and the calmer "later" copy. {date} is filled from quoteValidUntil.
  "pp.validity":
    "Offer valid until: {date} · if it lapses, {advisor} will prepare an up-to-date offer.",
  "pp.advisorNoteTitle": "A note from your advisor",
  // N3 (#210) — the named variant, used when advisorName resolves. {advisor} in the copy
  // below falls back to "your advisor" when the name is null (never a fake name).
  "pp.advisorNoteTitleNamed": "A note from {advisor}",
  "pp.advisorFallback": "your advisor",
  "pp.deferNote":
    "Noted. No rush — your offer is valid until {date}. In the meantime {advisor} won't call you; you can respond here whenever you're ready.",
  "pp.deferNoteNoDate":
    "Noted. No rush. In the meantime {advisor} won't call you; you can respond here whenever you're ready.",

  // TEKLIF-AL — the authenticated re-quote surface.
  "nav.quote": "Request a quote",
  "qr.title": "Request a quote",
  "qr.subtitle": "A few details are all we need — your advisor takes it from there.",
  "qr.forWhom": "Who it's for",
  "qr.name": "Full name",
  "qr.phone": "Phone",
  "qr.email": "E-mail",
  "qr.forWhomNote":
    "This request is created in your name. Your identity is already on file — no need to re-enter it.",
  "qr.pickProduct": "Which product?",
  "qr.product.trafik": "Compulsory MTPL",
  "qr.product.kasko": "Kasko",
  "qr.product.dask": "DASK",
  "qr.product.seyahat": "Travel health",
  "qr.product.saglik": "Health",
  "qr.fieldsNote": "We only ask for what this product needs.",
  "qr.f.plate": "Plate",
  "qr.f.plateHint": "e.g. 34 ABC 123",
  "qr.f.vin": "Chassis No (VIN) — optional",
  "qr.f.vinHint": "You may enter the VIN instead of the plate.",
  "qr.f.address": "Address",
  "qr.f.uavt": "UAVT address code — optional",
  "qr.f.uavtHint": "10-digit address code (if you know it).",
  "qr.f.grossM2": "Gross m²",
  "qr.f.structure": "Structure type",
  "qr.f.buildYear": "Build year",
  "qr.f.floor": "Floor",
  "qr.f.choose": "Select",
  "qr.structure.betonarme": "Reinforced concrete",
  "qr.structure.celik": "Steel",
  "qr.structure.yigma": "Masonry",
  "qr.structure.diger": "Other",
  "qr.f.destination": "Destination country / region",
  "qr.f.startDate": "Start date",
  "qr.f.endDate": "End date",
  "qr.f.travelers": "Number of travellers",
  "qr.f.sgk": "SGK status",
  "qr.sgk.sgkli": "SGK-insured",
  "qr.sgk.sgksiz": "Not SGK-insured",
  "qr.sgk.bilinmiyor": "Not sure",
  "qr.f.hospital": "Hospital preference — optional",
  "qr.f.declarationNote":
    "For your privacy, the health declaration is completed offline with your advisor.",
  "qr.f.acikRiza": "I give explicit consent for my health data to be processed for this quote.",
  "qr.submit": "Send request",
  "qr.submitting": "Sending…",
  "qr.successTitle": "Your request has been received",
  "qr.successBody": "Your advisor will prepare quotes for you shortly.",
  "qr.newRequest": "Start a new request",
  "qr.profileError": "Couldn't load right now. You can reach your advisor.",
  "qr.err.vehicleRequired": "Please enter a plate or chassis number.",
  "qr.err.plateFormat": "Enter the plate like the example (34 ABC 123).",
  "qr.err.addressRequired": "Please enter an address.",
  "qr.err.uavtFormat": "The UAVT code must be 10 digits.",
  "qr.err.destinationRequired": "Please enter the destination.",
  "qr.err.acikRizaRequired": "Explicit consent is required to continue.",
  "qr.err.rate": "Too many attempts — please try again shortly.",
  "qr.err.generic": "We couldn't send your request — please try again.",
};

// The merged dictionary the customer I18nProvider feeds the foundation machinery.
export const dictionaries = {
  tr: { ...baseTr, ...tr },
  en: { ...baseEn, ...en },
} as const;
